import gql from "graphql-tag";
import fetch from "node-fetch";
import CONTEXT from "./graphqlapi";
import client from "../../common/Apolloconfig/index";

//Get All Neighborhood name
const QUERY_getblog = gql`
  query getblog(
    $start: Int
    $limit: Int
    $orderBy: String
    $order: String
    $fields: String
  ) {
    getblog(
      start: $start
      limit: $limit
      orderBy: $orderBy
      order: $order
      fields: $fields
    ) {
      id
      title
      sidebartitle
      description
      featuredimage
      metatitle
      metakeyword
      metadescription
      pageurl
      createdtime
      updatedtime
      shortdescription
      mappageurl
    }
  }
`;

//Get list by own query
async function getblog(getdata) {
  return new Promise((resolve, reject) => {
    client
      .query({
        query: QUERY_getblog,
        options: {
          fetch: fetch,
        },
        variables: {
          start: getdata.start,
          limit: getdata.limit,
          orderBy: getdata.orderBy,
          order: getdata.order,
          fields: JSON.stringify(getdata.fields),
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export { getblog };
